import { callEdgeFunction } from '@/master-data/supabase.client';

export interface VerseMetrics {
  dau: number;
  wau: number;
  mau: number;
}

export interface KpiActiveUsers {
  total: VerseMetrics;
  w2: VerseMetrics;
  w3: VerseMetrics;
  generatedAt: string;
  cached: boolean;
}

export async function getKpiActiveUsers(): Promise<KpiActiveUsers> {
  return callEdgeFunction<KpiActiveUsers>('kpi-active-users', {});
}

export interface RetentionMetrics {
  cohortSize: number;
  retained: number;
  rate: number;
}

export interface KpiRetention {
  total: RetentionMetrics;
  w2: RetentionMetrics;
  w3: RetentionMetrics;
  generatedAt: string;
  cached: boolean;
}

export async function getKpiRetention(): Promise<KpiRetention> {
  return callEdgeFunction<KpiRetention>('kpi-retention', {});
}
